import React, { useImperativeHandle } from "react"
import { RouterProvider } from "react-router-dom"
import MasterProvider from "@/components/provider"
import GlobalStyles from "@/styles/GlobalStyles"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import routes from "@/routes"
import { notification } from "antd"
import { notificationRef } from "./core/refs"

function MyApp() {
    const [api, contextHolder] = notification.useNotification()

    useImperativeHandle(notificationRef, () => api)

    return (
        <>
            {contextHolder}
            <GlobalStyles />
            <RouterProvider router={routes} />
            <ReactQueryDevtools />
        </>
    )
}

export default function SchedulerApp() {
    return (
        <MasterProvider>
            <MyApp />
        </MasterProvider>
    )
}
